// No reducer here, but we throw actions (for analytics)
// This is used by desktop and mobile, since this is obasically analytics-only
// if you start adding functionality, consider splitting them!
export const LOADED_SPLASH = "LANDING.LOADED_SPLASH";
export const CLICK_SIGNUP = "LANDING.CLICK_SIGNUP";
export const CLICK_LOGIN = "LANDING.CLICK_LOGIN";
export const CONFIRM_RECAPTCHA_SUCCESS = "LANDING.CONFIRM_RECAPTCHA_SUCCESS";

export function loadSplash() {
	return { type: LOADED_SPLASH };
}

export function clickSignup() {
	return { type: CLICK_SIGNUP };
}

export function clickLogin() {
	return { type: CLICK_LOGIN };
}



// WEBPACK FOOTER //
// ./src/ducks/splash.js